import {v4 as uuidv4} from 'uuid'
import {SLOT_TYPES, SOURCES} from '@/config/layoutConfig'

class StatisticsViewService {
    constructor(store) {
        this.store = store
    }

    async setStaticsView(data) {
        const slots = this.createStatisticsSlots(data)
        const tabName = `Statistics ${data.data.description}`

        const tab = await this.store.dispatch("grid/addNewTab", {
            tabName,
            layout: 'statistics',
            slots
        })

        if (tab.status) {
            await this.store.dispatch("grid/setActiveTab", tab.id)
            this.store.commit("grid/forceLayoutSlots", slots)
        }
    }

    createStatisticsSlots(data) {
        const slots = []
        const chartDataId1 = uuidv4()
        const chartDataId2 = uuidv4()

        // Info slot
        slots.push(this.createInfoSlot(data))

        // Camera status chart
        slots.push(this.createCameraChartSlot(data, chartDataId1))

        // Camera data slot
        slots.push(this.createCameraDataSlot(data, chartDataId1))

        // Unit map slot
        slots.push(this.createUnitMapSlot(data))

        // Events chart
        slots.push(this.createEventsChartSlot(data, chartDataId2))

        // Events data slot
        slots.push(this.createEventsDataSlot(data, chartDataId2))

        return slots
    }

    createInfoSlot(data) {
        return {
            name: data.data.description,
            pos: 1,
            data: {
                url: data.data.info_url,
                in_app_source: SOURCES.SUBSYSTEM_TREE
            },
            type: SLOT_TYPES.INFO,
            id: "444e7e66-f0a4-4ba3-b290-4d3af4a3347c"
        }
    }

    createCameraChartSlot(data, chartDataId) {
        return {
            name: 'Chart Cameras',
            pos: 2,
            data: {
                chartData: {
                    id: chartDataId,
                    chart_id: chartDataId,
                    data: [],
                    name: "Status Cameras",
                    chart: "pie",
                    field: "online",
                    model: "CamerasProxy",
                    filters: {units: [data.data.id]},
                    keep_filters: ['units'],
                    date_field: null
                },
            },
            type: SLOT_TYPES.CHARTS_SDK,
            id: "f0673221-7b2f-40a9-894e-9962a1719435"
        }
    }

    createCameraDataSlot(data, chartDataId) {
        return {
            name: 'Chart Cameras Data',
            pos: 3,
            data: {
                chart_id: chartDataId,
                model: "CamerasProxy",
                filters: {units: [data.data.id]}
            },
            type: SLOT_TYPES.CHARTS_SDK_DATA,
            id: "03eff0d1-66e1-4730-b5c4-6b10c268b483"
        }
    }

    createUnitMapSlot(data) {
        return {
            name: 'Unit map',
            pos: 4,
            data: {
                unit_id: data.data.id
            },
            type: SLOT_TYPES.UNITS_MAP,
            id: "9c05f0f1-ae94-4824-8da2-d4e6c0976fbc"
        }
    }

    createEventsChartSlot(data, chartDataId) {
        return {
            name: 'Chart Events',
            pos: 5,
            data: {
                chartData: {
                    id: chartDataId,
                    chartId: chartDataId,
                    data: [],
                    name: "Events",
                    chart: "bar",
                    field: "created",
                    model: "Alarm",
                    filters: {units: [data.data.id]},
                    keep_filters: ['units'],
                    date_field: null
                },
            },
            type: SLOT_TYPES.CHARTS_SDK,
            id: "125214e7-8d52-44a8-b6c2-cdd518b59067"
        }
    }

    createEventsDataSlot(data, chartDataId) {
        return {
            name: 'Chart Events Data',
            pos: 6,
            data: {
                chart_id: chartDataId,
                model: "Alarm",
                filters: {units: [data.data.id]}
            },
            type: SLOT_TYPES.CHARTS_SDK_DATA,
            id: "71a8b78a-cd8d-4e8a-a7ef-fed4038ffae4"
        }
    }
}

export default StatisticsViewService
